import { Badge, Popper, styled } from '@mui/material';

/* CSS Style. */
export const customized_style = {
    itemPaper_main: {
        borderRadius: 5,
        mx: 1,
        mt: 1,
        minHeight: 755,
        height: '92vh',
        boxShadow: '0px 1px 1px 1px rgba(0, 0, 0, 0.1)',
    },
    itemPaper: {
        borderRadius: 5,
        m: 2,
        p: 3,
        minHeight: 780,
        height: '90.5vh',
        boxShadow: '0px 1px 1px 1px rgba(0, 0, 0, 0.1)',
    },
    itemPaper_overflow: {
        borderRadius: 5,
        m: 2,
        p: 3,
        minHeight: 500,
        height: '90.5vh',
        boxShadow: '0px 1px 1px 1px rgba(0, 0, 0, 0.1)',
        overflow: 'auto',
    },
    itemTabs: {
        '& .MuiTabs-root': {
            height: '36px',
        },
        '& .MuiTabs-root.css': {
            height: '36px',
        },
        '& .MuiButtonBase-root': {
            p: 0,
            m: 0,
        },
        '& .MuiTabs-scroller': {
            height: '36px',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: '#003a52',
        },
    },
    itemTab: {
        minHeight: '36px',
        fontSize: '13px',
        bgcolor: 'lightgrey',
        '&.Mui-selected': {
            bgcolor: 'white',
            fontWeight: '500',
        },
        fontWeight: '400',
    },
    itemMenu: {
        color: '#003a52',
        fontSize: '0.9rem',
        fontWeight: 'medium',
        ':hover': {
            textDecoration: 'underline',
            fontWeight: 'bold',
        },
    },
    itemSubMenu: {
        fontSize: '0.9rem',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
    },
    itemDatagrid_Typography: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        fontSize: 11,
    },
    itemDatagrid_LongTypography: {
        height: '100%',
        fontSize: '11px',
        direction: 'ltr',
        textAlign: 'left',
        textOverflow: 'ellipsis',
        display: 'flex',
        alignItems: 'center',
    },
    itemIcon: {
        color: '#00647e',
        bgcolor: 'white',
        borderRadius: 5,
        p: '2px',
    },
};

export const customStyle = {
    headerStyle: {
        border: '1px solid black',
        fontWeight: 'bold',
        backgroundColor: '#666666',
        color: '#ffffff',
        textAlign: 'center',
        fontSize: '10px',
        width: '25%',
        whiteSpace: 'pre-line',
        fontFamily: 'Calibri, NotoSans',
    },
    headerStyle_status: {
        border: '1px solid black',
        fontWeight: 'bold',
        backgroundColor: '#666666',
        color: '#ffffff',
        textAlign: 'center',
        fontSize: '10px',
        fontFamily: 'Calibri, NotoSans',
    },
    headerStyle_statusMessage: {
        border: '1px solid black',
        fontWeight: 'bold',
        backgroundColor: '#666666',
        color: '#ffffff',
        textAlign: 'center',
        fontSize: '10px',
        fontFamily: 'Calibri, NotoSans',
    },
    tableCellStyle: {
        border: '1px solid black',
        width: '33%',
        textAlign: 'center',
        fontSize: '10px',
        fontFamily: 'Calibri, NotoSans',
    },
    tableCellStyle_status: {
        width: '70px',
        border: '1px solid black',
        textAlign: 'center',
        fontSize: '10px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        fontFamily: 'Calibri, NotoSans',
    },
    tableCellStyle_statusMessage: {
        width: '180px',
        border: '1px solid black',
        textAlign: 'left',
        fontSize: '10px',
        bgcolor: '#FFFF00',
        fontFamily: 'Calibri, NotoSans',
    },
};

/** Style for Badge Component of New Updates Button */
export const StyledBadge = styled(Badge)(() => ({
    '& .MuiBadge-badge': {
        right: 10,
        top: 9,
        padding: '0',
        fontSize: '5px',
        height: '10px',
        minWidth: '10px',
    },
}));

export const dataGridOverrideStyle = {
    '& .MuiDataGrid-main': {
        borderRadius: 2,
        boxShadow: 2,
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 'bold',
        fontSize: '13px',
    },
    '& .MuiDataGrid-toolbarContainer': {
        p: 0,
        mb: '8.5px',
    },
    '& .MuiButtonBase-root': {
        fontSize: '13px',
        fontWeight: 'bold',
    },
    '& .MuiDataGrid-footerContainer': {
        border: 'none',
    },
    '& .grouped-column-style': {
        backgroundColor: '#dfdfdf',
    },
    '& .normal-column-style': {
        backgroundColor: '#f1f1f1',
        '& .MuiDataGrid-columnSeparator': {
            color: '#f1f1f1',
        },
    },
    '& .normal-separator-column-style': {
        backgroundColor: '#f1f1f1',
        '& .MuiDataGrid-columnSeparator': {
            color: '#ffffff',
        },
    },

    // default (initial render) — set to standard
    '--headerGroupRowHeight': '30px',
    '--headerRowHeight': '29px',

    // case applied per desity (added automatically by DataGrid to root)
    '&.MuiDataGrid-densityCompact, &[class*="MuiDataGrid-densityCompact"], &.MuiDataGrid-root--densityCompact': {
        '--headerGroupRowHeight': '21px',
        '--headerRowHeight': '20px',
    },
    '&.MuiDataGrid-densityStandard, &[class*="MuiDataGrid-densityStandard"], &.MuiDataGrid-root--densityStandard': {
        '--headerGroupRowHeight': '30px',
        '--headerRowHeight': '29px',
    },
    '&.MuiDataGrid-densityComfortable, &[class*="MuiDataGrid-densityComfortable"], &.MuiDataGrid-root--densityComfortable':
        {
            '--headerGroupRowHeight': '39px',
            '--headerRowHeight': '38px',
        },

    // default filler hidden, replaced by overlay
    '& .MuiDataGrid-scrollbarFiller--header': { display: 'none' },

    // overlay column header, replaces the default scrollbar header
    '& .MuiDataGrid-columnHeaders': {
        position: 'relative',

        // grouped header color
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            right: 0,
            width: '30px',
            height: 'var(--headerGroupRowHeight)',
            backgroundColor: '#dfdfdf',
        },

        // normal header color
        '&::after': {
            content: '""',
            position: 'absolute',
            top: 'var(--headerGroupRowHeight)',
            right: 0,
            width: '30px',
            height: 'var(--headerRowHeight)',
            backgroundColor: '#f1f1f1',
        },
    },
};

/** Duty Record's detail panel grid styles. */
export const dutyEntryDetailGridSx = {
    fontSize: '11px',
    borderRadius: '8px',
    height: '300px',
    overflow: 'auto',
    bgcolor: '#ffffff',
    border: 0,
    // 담당자가 손대야 하는 셀을 빨간 테두리로 드러낸다. 두 경우가 같은 표시를 쓴다.
    // - 잘못된 입력(음수 등)으로 오류 상태가 된 편집 셀. 이 표시가 없으면 저장만
    //   조용히 막혀 담당자가 이유를 알 수 없다.
    // - 서버가 empty 힌트를 보낸 셀(Tier 필수 품목의 미선택 등).
    '& .MuiDataGrid-cell--editing .Mui-error, & .duty-detail-cell--empty': {
        outline: '1.5px solid #d32f2f',
        outlineOffset: '-1.5px',
        backgroundColor: 'rgba(211, 47, 47, 0.08)',
    },
    '& .MuiDataGrid-withBorderColor': { borderColor: 'transparent' },
    minHeight: 216,
    border: 0,
    '& .MuiDataGrid-columnHeader': {
        backgroundColor: '#ffffff',
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontSize: '11px', // 원하는 크기로 변경
    },
    '& .MuiDataGrid-columnSeparator': { display: 'none' },
    '& .MuiDataGrid-cell': {
        textAlign: 'center',
        px: 1,
        fontSize: '11px',
        minHeight: '25px',
        lineHeight: '25px',
    },
    '& .MuiDataGrid-row': {
        minHeight: '25px !important',
    },

    '& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus': { outline: 'none' },
};

export const dutyEntryDetailCellTypographySx = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    fontSize: '11px',
};

export const tabsRootSx = {
    minHeight: 40,
    '& .MuiTabs-flexContainer': {
        gap: 0,
    },
    '& .MuiTab-root': {
        minHeight: 40,
        minWidth: 120,
        fontSize: 13,
        fontWeight: 600,
        textTransform: 'none',
        borderRadius: '10px 10px 0 0',
        transition: 'background-color 0.2s ease, color 0.2s ease',
    },
    '& .MuiTabs-indicator': {
        display: 'none',
    },
    bgcolor: '#dfdfdf',
    borderColor: '#dfdfdf',
    borderBottomColor: '#ffffff',
    borderRadius: '10px 10px 0 0',
    '&.Mui-selected': {
        bgcolor: '#ffffff', // selected tab background
        color: '#00647e',
        borderColor: '#dfdfdf',
        borderBottomColor: '#ffffff',
    },

    '& .MuiTab-root.Mui-selected': {
        bgcolor: '#ffffff',
        border: '2px solid #dfdfdf',
        borderBottom: '1px solid #ffffff',
    },
};
export const shipmentMonitoringAutocompleteSx = {
    flex: 1,

    '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
        m: 0,
        mt: 0,
        mb: 0,
        pl: '6px',
        pr: '30px',
        pt: 0,
        pb: 0,
        minHeight: 33,
        height: 33,
        maxHeight: 'auto',
        boxSizing: 'border-box',
        alignItems: 'center',
        fontSize: '11px',
    },
    '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiInputBase-input': {
        padding: '5px 4px 5px 8px',
        minHeight: 22,
        lineHeight: '22px',
        height: 'auto',
        boxSizing: 'border-box',
        fontSize: '11px',
    },
    '& .MuiAutocomplete-tag': {
        m: 0,
        mr: '3px',
        height: 20,
        maxHeight: 20,
        '& .MuiChip-label': { fontSize: '10px', px: 0.5, py: 0, lineHeight: 1.1 },
        '& .MuiChip-deleteIcon': { fontSize: '14px', width: 14, height: 14, m: '0 1px 0 -2px' },
    },
    '& .MuiAutocomplete-endAdornment': { top: '50%', transform: 'translateY(-50%)', right: 4 },
    '& .MuiAutocomplete-endAdornment .MuiSvgIcon-root': { fontSize: '18px' },
    alignSelf: 'center',
    display: 'flex',
    alignItems: 'center',
};

/** Autocomplete popper with a scrollable 13px listbox — shared by rate-management and shipment-monitoring filters. */
export const StyledPopper = styled(Popper)({
    '& .MuiAutocomplete-listbox': {
        fontSize: '13px',
        overflowY: 'auto',
    },
    overflowY: 'auto',
});

/** Inline form-field label (fixed 140px) used by rate-management and shipment-monitoring search forms. */
export const formLabelTypographySx = {
    display: 'inline',
    color: '#003a52',
    fontSize: '13px',
    fontWeight: 500,
    width: '140px',
    flexShrink: 0,
};

/** Card panel with a gray header strip, small form fields and a compact 11px DataGrid — used by the Packing List review and allocation screens. */
export const panelSx = { bgcolor: 'white', borderRadius: '10px', boxShadow: '0px 1px 2px 1px rgba(0, 0, 0, 0.1)', display: 'flex', flexDirection: 'column', overflow: 'hidden' };
export const panelTitleSx = { color: '#01354d', fontSize: '13px', fontWeight: 500 };
export const panelHeadSx = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1, px: 1.5, py: 0.75, bgcolor: '#f1f1f1', borderBottom: '1px solid #dfdfdf', flexShrink: 0 };
export const smallFieldSx = { '& .MuiInputBase-input': { fontSize: 12, py: '6px' }, '& .MuiInputLabel-root': { fontSize: 12 } };
export const gridSx = {
    border: 'none',
    fontSize: '11px',
    '& .MuiDataGrid-columnSeparator': { display: 'none' },
    '& .MuiDataGrid-columnHeader': { backgroundColor: '#f1f1f1' },
    '& .MuiDataGrid-columnHeaderTitle': { fontSize: '11px' },
    '& .MuiDataGrid-cell': { p: 0 },
    '& .MuiDataGrid-scrollbarFiller': { backgroundColor: '#f1f1f1' },
    '& .MuiInputBase-input': { px: 1, fontSize: '11px' },
};
